<template>
  <div class="rz-main">
    <div class="rz-top">
      <div class="rz-topbg">
        <img src="../assets/head.png" />
      </div>
    </div>
    <div class="mui-content">
      <div class="rz-state" style="text-align: center">
        <span id="displayName_blue">证书状态：有效</span>
      </div>
      <div class="rz-infor">
        <div class="rz-item">
          <p style="text-align: center">证书信息</p>
          <p>获证组织名称：山东知同文传数字科技有限公司</p>
          <p>注册地址：济南高新区新宇路南首齐鲁软件园大厦 8层 808房间</p>
          <p>生产经营地址：济南高新区新宇路南首齐鲁软件园大厦8层 808房间</p>
          <br />
          <p>证书编号：0482024Q0148ROS</p>
          <p>认证标准：GB/T 19001-2016/ISO 9001:2015</p>
          <p>认证领域：质量管理体系</p>
          <p>认证范围：计算机应用软件开发及相关管理活动。</p>
          <!-- <p>监一审核日期：</p>
          <p>监二审核日期：</p> -->
          <p>有效截止日期：2027-04-05</p>
          <p>认证机构名称：北京泰瑞特认证有限责任公司</p>
        </div>
        <div class="rz-item">
          <br />
          <br />
          <br />
          <p>认证证书有效性的进一步查询可登陆：</p>
          <p>泰瑞特认证网站：www.tirt.org.cn</p>
          <p>中国国家认证认可监督管理委员会网站：www.cnca.gov.cn</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

export default {};
</script>
<style lang="scss" scoped>
.mui-content {
  font-family: "微软雅黑";
  margin-top: 0;
  background: url("../assets/CertProcute.jpg") bottom center no-repeat;
  background-size: 100% 100%;
  width: 100%;
  // height: 100%;
  color: #666;
  text-shadow: 0 1px 0 #000;
  font-size: 16px !important;
}

.rz-main {
  width: 100%;
  height: 100%;
}
.rz-main .rz-top {
  text-align: right;
  // line-height: 2em;
  position: relative;
}

.rz-main .rz-top .rz-topbg {
  box-sizing: border-box;
  overflow: hidden; /* 防止内容溢出 */
  display: flex; /* 使用flex布局 */
  justify-content: center; /* 水平居中 */
  align-items: center; /* 垂直居中 */
}
.rz-main .rz-top .rz-topbg img {
  width: 100%;
  height: 100%;
}
.rz-main .rz-top .rz-bigft {
  font-size: 28px;
  font-weight: bold;
}
.rz-main .rz-top .rz-smft {
  font-size: 20px;
}
.rz-main .rz-state {
  font-size: 22px;
  text-align: right;
  padding: 0.5em 1em;
  margin: 0;
}
.rz-main .rz-state span {
  // font-size: 28px;
  color: #f8e619;
  font-weight: bold;
}
.rz-main .rz-infor {
  padding: 1em;
}
.rz-main .rz-infor .rz-item {
  line-height: 1.3em;
  margin-bottom: 1.2em;
}
.rz-main .rz-infor .rz-item p {
  padding: 0.2em 0;
  margin: 0;
  font-size: 18px;
  text-align: left;
}

#displayName_yellow {
  color: #f8e619;
}
#displayName_red {
  color: Red;
}
#displayName_blue {
  color: #5db95b;
}
</style>
